import { render, staticRenderFns } from "./list-type-dialog.vue?vue&type=template&id=bf8290dc"
import script from "./list-type-dialog.vue?vue&type=script&lang=js"
export * from "./list-type-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports